import React, {
  useState,
  Fragment,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import {
  AppBar,
  Toolbar,
  List,
  ListItem,
  Typography,
  Button,
  Grid,
  IconButton,
  MenuItem,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
} from "@material-ui/core";
import useReactRouter from "use-react-router";
import { makeStyles } from "@material-ui/styles";
import Useractive from "./useractive";
import { LangContext } from "../../Context/Langcontext";
import ChangeLanguage from "./ChangeLanguage";
// import { IoMdList } from "react-icons/io";
import { FaUserCircle } from "react-icons/fa";
import MenuMobile from "./MenuMobile";

const useStyle = makeStyles((theme) => ({
  root: { height: "100%", width: "100%" },
  appbar: {
    zIndex: 15,
    height: "5rem",
    width: "100%",
    justifyContent: "center",
    // backgroundColor: "#ffffff",
    // transition: "box-shadow 300ms ease-in-out 0s",
    // boxShadow: "rgba(0, 0, 0, 0.1) 0px 8px 8px -8px",
  },
  display: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  btnlogin: {
    border: "1px solid #E16733",
    margin: "0.5rem",
    borderRadius: 8,
    padding: "0.3rem 1.25rem",
    fontSize: "1rem",
    fontWeight: 200,
    whiteSpace: "nowrap",
    "&:hover": {
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  btnsignin: {
    color: "#ffffff",
    backgroundColor: "#E16733",
    margin: "0.5rem",
    borderRadius: 8,
    padding: "0.3rem 1.25rem",
    fontSize: "1rem",
    fontWeight: 200,
    whiteSpace: "nowrap",
    "&:hover": {
      background: "#E16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  text: {
    color: theme.palette.primary.main,
    // "&:hover": {
    //   color: "#E16733",
    // },
  },
  untext: {
    color: "#595A5A",
    "&:hover": {
      color: "#E16733",
    },
  },
  imageDesktop: {
    width: "auto",
    height: "3.5rem",
    marginLeft: "0.5rem",
    transition: ".5s",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      display: "block",
    },
  },
  imageMobile: {
    width: "auto",
    height: "3.5rem",
    marginLeft: "0.5rem",
    transition: ".5s",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  usercomp: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  cardStyle: {
    boxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    width: "100%",
  },
  pages: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      display: "block",
    },
  },
  hidden: {
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  imagelogo: {
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      justifyContent: "center",
    },
    [theme.breakpoints.down("md")]: {
      display: "flex",
      justifyContent: "center",
    },
    [theme.breakpoints.up("lg")]: {
      display: "block",
    },
  },
  menuitem: {
    margin: "0.5rem",
    fontWeight: 200,
    borderRadius: 25,
  },
  onHover: {
    width: "100%",
    "&:hover": {
      color: theme.palette.primary.main,
      // transform: "scale(1.05,1.05)"
    },
  },
}));

const AppbarItem = ({ children }) => {
  const classes = useStyle();
  const { history, location } = useReactRouter();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [barstyle, setbarstyle] = useState({
    color: "#ffe4ba",
    boxshadow: "unset",
    transition: "unset",
  });

  // const [onPath, setOnPath] = useState("/home/main");

  let list = [
    { name: lang.HOME, path: "/home/main" },
    { name: lang.SERVICE, path: "/home/service" },
    { name: lang.PRICING, path: "/home/pricing" },
    { name: lang.DOCUMENT, path: "/home/document" },
    { name: lang.SUPPORT, path: "/home/support" },
  ];

  const goSignIn = () => {
    history.push("/user/login");
  };

  const goRegister = () => {
    history.push("/user/register");
  };

  const prevOpen = useRef(open);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
    // setOnPath(history.location.pathname);
    // console.log(history.location.pathname);
  }, [open]);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const UserListItem = () => {
    return (
      <Paper className={classes.cardStyle}>
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList
            autoFocusItem={open}
            id="menu-list-grow"
            onKeyDown={handleListKeyDown}
          >
            <MenuItem onClick={goSignIn} className={classes.menuitem}>
              {lang.Signin}
            </MenuItem>
            <MenuItem onClick={goRegister} className={classes.menuitem}>
              {lang.Register}
            </MenuItem>
          </MenuList>
        </ClickAwayListener>
      </Paper>
    );
  };

  const listenScrollEvent = useCallback(
    (e) => {
      if (window.scrollY > 400) {
        setbarstyle({
          ...barstyle,
          color: "#FFFFFF",
          boxshadow: "rgba(0, 0, 0, 0.1) 0px 8px 8px -8px",
          transition: "box-shadow 300ms ease-in-out 0s",
        });
      } else if (window.scrollY > 65 && window.screenY < 390) {
        setbarstyle({
          ...barstyle,
          color: "transparent",
          boxshadow: "unset",
          transition: "unset",
        });
      } else {
        setbarstyle({
          ...barstyle,
          color: "#ffe4ba",
          boxshadow: "unset",
          transition: "unset",
        });
      }
    },
    [barstyle]
  );

  useEffect(() => {
    if (location.pathname === "/home/main") {
      window.addEventListener("scroll", listenScrollEvent);
      return () => {
        window.removeEventListener("scroll", listenScrollEvent);
      };
    } else {
    }
  }, [location, listenScrollEvent]);

  return (
    <Fragment>
      <AppBar
        className={classes.appbar}
        style={{
          backgroundColor:
            location.pathname === "/home/main" ? barstyle.color : "#FFFFFF",
          boxShadow:
            location.pathname === "/home/main"
              ? barstyle.boxshadow
              : "rgba(0, 0, 0, 0.1) 0px 8px 8px -8px",
          transition:
            location.pathname === "/home/main"
              ? barstyle.transition
              : "box-shadow 300ms ease-in-out 0s",
        }}
      >
        <Toolbar style={{ justifyContent: "center", display: "flex" }}>
          <Grid container spacing={0} alignItems="center">
            <Grid item xs={4} sm={4} md={4} lg={3} className={classes.hidden}>
              {localStorage.getItem("token") !== null ? (
                <MenuMobile />
              ) : (
                <MenuMobile />
              )}
            </Grid>
            <Grid
              item
              xs={4}
              sm={4}
              md={4}
              lg={3}
              className={classes.imagelogo}
            >
              <img
                className={classes.imageDesktop}
                src={require("../../images/LOGO/logo2.png")}
                alt="logo"
                onClick={() => {
                  history.replace("/home");
                  window.scrollTo(0, 0);
                }}
              />

              <img
                className={classes.imageMobile}
                src={require("../../images/LOGO/logo3.png")}
                alt="logo"
                onClick={() => {
                  history.replace("/home");
                  window.scrollTo(0, 0);
                }}
              />
            </Grid>
            <Grid item md={6} lg={6} className={classes.pages}>
              <List className={classes.display}>
                {list.map((item, index) => {
                  return (
                    <ListItem
                      key={item.name}
                      onClick={() => {
                        history.push(item.path);
                        window.scrollTo(0, 0);
                      }}
                    >
                      <Typography
                        className={
                          location.pathname.startsWith(item.path)
                            ? classes.text
                            : classes.untext
                        }
                        style={{
                          fontSize: "1rem",
                          marginRight: "2.5rem",
                          fontWeight: location.pathname.startsWith(item.path)
                            ? 400
                            : 200,
                          cursor: "pointer",
                        }}
                      >
                        {item.name.toUpperCase()}
                      </Typography>
                    </ListItem>
                  );
                })}
              </List>
            </Grid>

            <Grid
              item
              xs={4}
              sm={4}
              md={4}
              lg={3}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <ChangeLanguage />

              {localStorage.getItem("token") !== null ? (
                <Useractive />
              ) : (
                <>
                  <div className={classes.usercomp}>
                    <Button
                      className={classes.btnlogin}
                      onClick={() => {
                        goSignIn();
                      }}
                    >
                      {lang.Signin}
                    </Button>
                    <Button
                      className={classes.btnsignin}
                      onClick={() => {
                        goRegister();
                      }}
                    >
                      {lang.Register.toUpperCase()}
                    </Button>
                  </div>

                  <div className={classes.sectionMobile}>
                    <IconButton
                      onClick={handleToggle}
                      ref={anchorRef}
                      aria-controls={open ? "menu-list-grow" : undefined}
                    >
                      <FaUserCircle color="#595A5A" />
                    </IconButton>
                  </div>
                  <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    transition
                    disablePortal
                  >
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{
                          transformOrigin:
                            placement === "bottom"
                              ? "center top"
                              : "center bottom",
                        }}
                      >
                        <UserListItem />
                      </Grow>
                    )}
                  </Popper>
                </>
              )}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <main>{children}</main>
    </Fragment>
  );
};

export default AppbarItem;
